import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';

import { createSnack } from 'snackbar/snackbarSlice';

import { useSetEditNotificationsMutation } from '../terminalDetailsEndpoints';
import Filters from './Filters';

const styles = {
  toggles: {
    '.MuiTypography-root': {
      whiteSpace: 'nowrap',
    },
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: { lg: 'flex-end', xs: 'space-around' },
  },
};

const TerminalDetailsAlertsFilters = ({
  filtersState,
  isActiveEmail: isActiveEmailProp,
  isActiveSMS: isActiveSMSProp,
  resetFilters,
  setFiltersState,
}) => {
  const locationId = parseInt(useParams().terminalId);

  const dispatch = useDispatch();

  const [editNotificationSettings] = useSetEditNotificationsMutation();

  const [{ isActiveEmail, isActiveSMS }, setIsActive] = useState({
    isActiveEmail: false,
    isActiveSMS: false,
  });

  useEffect(() => {
    setIsActive({ isActiveEmail: isActiveEmailProp, isActiveSMS: isActiveSMSProp });
  }, [isActiveEmailProp, isActiveSMSProp]);

  const handleChangeNotifications = ({ target: { name, checked } }) => {
    const isEmail = name === 'isActiveEmail';
    setIsActive(state => ({ ...state, [name]: checked }));
    editNotificationSettings({
      isActive: checked,
      isEmail,
      locationId,
    })
      .unwrap()
      .then(({ message }) => {
        dispatch(createSnack({ message }));
      })
      .catch(error => {
        // reset notification toggle on error
        setIsActive({
          isActiveEmail: isEmail ? !checked : isActiveEmail,
          isActiveSMS: isEmail ? isActiveEmail : !checked,
        });
        dispatch(
          createSnack({
            message: error.data.title,
            options: { variant: 'error' },
          })
        );
      });
  };

  return (
    <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'row', my: { md: 3, xs: 2 } }}>
      <Box sx={{ alignItems: 'center', display: { md: 'flex', xs: 'none' }, flex: 1 }}>
        <Filters
          filtersState={filtersState}
          resetFilters={resetFilters}
          setFiltersState={setFiltersState}
        />
      </Box>
      <FormGroup sx={styles.toggles}>
        <FormControlLabel
          control={
            <Switch
              checked={isActiveEmail}
              name="isActiveEmail"
              onChange={handleChangeNotifications}
            />
          }
          label="Email alerts"
        />
        <FormControlLabel
          control={
            <Switch checked={isActiveSMS} name="isActiveSMS" onChange={handleChangeNotifications} />
          }
          label="SMS alerts"
        />
      </FormGroup>
    </Box>
  );
};

TerminalDetailsAlertsFilters.propTypes = {
  filtersState: PropTypes.shape({}).isRequired,
  isActiveEmail: PropTypes.bool.isRequired,
  isActiveSMS: PropTypes.bool.isRequired,
  resetFilters: PropTypes.func.isRequired,
  setFiltersState: PropTypes.func.isRequired,
};

export default TerminalDetailsAlertsFilters;
